import { useState, useRef, useEffect, useMemo, useCallback } from 'react';
import GlobalSearch from '../../../../src/components/sharedChild/grid/globalSearch';
import 'react-circular-progressbar/dist/styles.css';
import { Link, useNavigate } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import { AgGridReact } from 'ag-grid-react';
import CustomStatusBar from '../../../../src/components/sharedChild/grid/customStatusBar';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAccountsDropdown,
  getActiveOwners,
  getGridDataByModuleKey,
  getQuoteList,
} from '../../../redux/selector';
import { columnTypes } from '../../../shared/initials';
import { DateFormatter } from '../../../shared/controls/formatters';
import gridOptionsConfig from '../../../components/sharedChild/grid/gridOptionsConfig';
import useFetchIfNeeded from '../../../redux/useFetchIfNeeded';
import { fetchDataAndUpdateStore } from '../../../redux/actions';
import { dropdownPayload, quoteInputData } from '../../../shared/constants';
import Loader from '../../../shared/component/Loader';
import { isLoadingByKey } from '../../../shared/controls/methods/getLoadingState';
import useQuoteColumnDefs from './useQuoteColumnDefs';
import apiServices from '../../../services/service';
import { toast } from 'react-toastify';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import FilterHandler from '../../../components/sharedChild/grid/filterHandler';

const Dashboard = () => {
  const stateData = useSelector((state) => state);
  let storeLoading = isLoadingByKey(stateData, 'quoteList');
  const navigate = useNavigate();
  const quoteData = useSelector(getQuoteList);
  const [rowData, setRowData] = useState(quoteData);
  const gridOptions = gridOptionsConfig('quoteList', navigate);
  const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
  const [selectedTheme, setSelectedTheme] = useState('balham');
  const [loading, setLoading] = useState(storeLoading);
  const gridData = useSelector(getGridDataByModuleKey('quoteList'));
  const dispatch = useDispatch();
  const gridRef = useRef();
  const accountDropdown = useSelector(getAccountsDropdown);
  const owner = useSelector(getActiveOwners);
  const [acordForm, setAcordForm] = useState('');
  const [show, setShow] = useState(false);
  const [selectedState, setSelectedState] = useState('');
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [gridParams, setGridParams] = useState(null);

  const states = ['Select State', 'California', 'Texas', 'New York'];
  const businessLines = [
    {
      id: 1,
      img: '/assets/quoteAi/images/comensation.svg',
      label: 'Worker Compensation',
      color: 'bg-blue',
    },
    {
      id: 2,
      img: '/assets/quoteAi/images/liability.svg',
      label: 'General Liability',
      color: 'bg-lightblue',
    },
    { id: 3, img: '/assets/quoteAi/images/auto.svg', label: 'Auto', color: 'bg-yellow' },
    { id: 4, img: '/assets/quoteAi/images/property.svg', label: 'Property', color: 'bg-purple' },
    { id: 5, img: '/assets/quoteAi/images/package.svg', label: 'Package', color: 'bg-green' },
    { id: 6, img: '/assets/quoteAi/images/other.svg', label: 'Other', color: 'bg-lightgreen' },
  ];

  const handleStartQuote = () => {
    if (acordForm === 'no') {
      navigate('/quoteAI/insuredInformationPage'); // Navigate when "No" is selected
    } else {
      // Handle the "Yes" case or show an error if needed
    }
  };

  useEffect(() => {
    setLoading(storeLoading);
  }, [storeLoading]);

  useFetchIfNeeded(getQuoteList, fetchDataAndUpdateStore, {
    key: 'quoteList',
    inputData: quoteInputData,
  });

  useFetchIfNeeded(getAccountsDropdown, fetchDataAndUpdateStore, {
    key: 'accountDropdown',
    inputData: dropdownPayload,
  });

  // const [columnDefs] = useState([
  //   {
  //     headerName: 'Actions',
  //     headerCheckboxSelection: true,
  //     checkboxSelection: true,
  //     field: 'actions',
  //     minWidth: 80,
  //     maxWidth: 100,
  //     pinned: 'left',

  //     resizable: false,

  //     cellRenderer: (params) => {
  //       const rowData = { ...params.data, rowIndex: params.rowIndex };
  //       return (
  //         <div className="action-menu">
  //           <img
  //             src="/assets/images/edit.png"
  //             className="action-img1"
  //             onClick={() =>
  //               navigate(`/quoteAI/regularQuoteEdit?id=${params?.data?.id}`, {
  //                 state: rowData,
  //               })
  //             }
  //             alt="Edit Lead"
  //             title="Edit Lead"
  //           />

  //           <img
  //             src="/assets/images/view.png"
  //             className="action-img2"
  //             onClick={() =>
  //               navigate(`/quoteAI/regularQuoteView?id=${params?.data?.id}`, {
  //                 state: rowData,
  //               })
  //             }
  //             alt="View Lead"
  //             title="View Lead"
  //           />

  //           {/* <img
  //           src="/assets/images/trash.png"
  //           className="action-img2"
  //           onClick={""}
  //           alt="Delete Contact"
  //           title="Delete Contact"
  //         ></img> */}
  //         </div>
  //       );
  //     },
  //   },
  //   { headerName: 'Code', field: 'code' },
  //   { headerName: 'Subject', field: 'subject', filter: 'agTextColumnFilter' },
  //   { headerName: 'Account Name', field: 'accountName' },
  //   {
  //     headerName: 'Valid Until',
  //     field: 'validUntil',
  //     valueFormatter: DateFormatter,
  //   },
  //   {
  //     headerName: 'Total Amount',
  //     field: 'grandTotal',
  //     width: 80,
  //   },
  //   { headerName: 'Created Date', field: 'createdDateTime' },
  //   { headerName: 'Quote Owner', field: 'quoteOwner' },
  // ]);

  const columnDefs = useQuoteColumnDefs({
    accountDropdown,
    owner,
    gridData,
  });

  const defaultColDef = useMemo(() => ({
    sortable: true,
    editable: false,
    flex: 1,
    minWidth: 130,
    filter: true,
    resizable: true,
    enableValue: true,
    enableRowGroup: true,
    enablePivot: true,
  }));

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          // minWidth: 130,
          // width: 130,
          // maxWidth: 130,
          toolPanelParams: {
            suppressPivotMode: true, // 👈 Hide Pivot Mode toggle
            suppressRowGroups: false, // ✅ Allow row grouping
            suppressValues: false, // ✅ Allow aggregation if needed
            suppressPivots: true, // 👈 Hide the pivot section for columns
          },
        },
        {
          id: 'filters',
          labelDefault: 'Filters',
          labelKey: 'filters',
          iconKey: 'filter',
          toolPanel: 'agFiltersToolPanel',
          // minWidth: 180,
          // maxWidth: 400,
          // width: 250,
        },
      ].filter(Boolean),
      position: 'left',
      defaultToolPanel: 'none', //show off filter tab bydefault.
    };
  }, []);

  const handleGridReady = (params) => {
    gridRef.current = params;
    setGridParams(params);
    const columnOrderFromStore = gridData?.columnState;

    if (columnOrderFromStore) {
      params.columnApi.applyColumnState({
        state: columnOrderFromStore,
        applyOrder: true,
      });
    } else {
      // apply default column visibility if no saved state
      const fieldsToHide = [
       
      ];

      const defaultState = params.columnApi.getColumnState().map((col) => ({
        ...col,
        hide: fieldsToHide.includes(col.colId),
      }));

      params.columnApi.applyColumnState({
        state: defaultState,
        applyOrder: true,
      });
    }
  };

  const exportAll = async () => {
    setLoading(true);

    // Ensure filterJson is considered
    const fetchData = {
      ...quoteInputData,
      pageSize: gridData?.totalCount,
      searchText: gridData?.inputPayload?.searchText ? gridData?.inputPayload?.searchText : null,
      filterJson: gridData?.inputPayload?.filterJson ? gridData?.inputPayload?.filterJson : null,
    };

    try {
      const response = await apiServices.exportAllQuote(fetchData);

      if (response?.data && response.status === 200) {
        setLoading(false);
        // const responseText = typeof response.data === "string" ? response.data.trim() : "";

        if (response?.data.includes('Export initiated.')) {
          toast.warning(response?.data); // Show toast
          setLoading(false);
        } else {
          // Convert data to Blob for better handling
          const blob = new Blob([response.data], {
            type: 'text/csv;charset=utf-8;',
          });
          const url = URL.createObjectURL(blob);

          // Create and trigger download
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Quotes.csv');
          document.body.appendChild(link);
          link.click();

          // Cleanup
          document.body.removeChild(link);
          URL.revokeObjectURL(url); // Free memory
        }
      } else {
        console.error('No data received from API.');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error exporting quotes:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (
      gridRef.current?.api &&
      gridData?.quoteList?.length &&
      // campaignListDropdown?.length ||
      gridData?.inputPayload?.filterJson
    ) {
      try {
        // Parse filterJson
        const filterJson = JSON.parse(gridData.inputPayload.filterJson);

        // Extract campaign IDs
        const campaignIds = filterJson?.campaignId?.conditions
          ? filterJson.campaignId.conditions.map((condition) => condition.filter)
          : filterJson?.campaignId?.filter
            ? [filterJson.campaignId.filter]
            : [];

        // Extract tag IDs
        const tagIds = filterJson?.tagIds?.conditions
          ? filterJson.tagIds.conditions.map((condition) => condition.filter)
          : filterJson?.tagIds?.filter
            ? [filterJson.tagIds.filter]
            : [];
        console.log('Extracted Campaign IDs:', campaignIds);
        console.log('Extracted Tag IDs:', tagIds);

        // Create a mapping of campaignId -> campaignName
        const campaignMapping = rowData.reduce((acc, campaign) => {
          acc[campaign.id] = campaign.campaignName;
          return acc;
        }, {});

        // // Create a mapping of tagId -> tagName
        // const tagMapping = tagsList.reduce((acc, tag) => {
        //   acc[tag.id] = tag.name;
        //   return acc;
        // }, {});

        // Get campaign names from matched IDs
        const matchedCampaignNames = campaignIds.map(
          (id) => campaignMapping[id] || 'Unknown Campaign'
        );

        // Get tag names from matched IDs (flattened)
        // const matchedTagNames = tagIds
        //   .map((id) => tagMapping[id] || "Unknown Tag")
        //   .flat();

        console.log('Matched Campaign Names:', matchedCampaignNames);
        // console.log("Matched Tag Names:", matchedTagNames);

        // Update contacts with campaignName and tags
        const updatedContacts = gridData.account.map((account) => ({
          ...account,
          campaignName: matchedCampaignNames, // Correct format
          // tags: matchedTagNames, // Flattened array
        }));

        // Update grid data
        const updatedGridData = {
          ...gridData,
          account: updatedContacts,
        };
        console.log('🚀 ~ useEffect ~ updatedGridData:', updatedGridData);

        // Update the grid with new data
        gridRef.current.api.setGridOption('rowData', updatedGridData.account);
        gridRef.current.api.refreshCells();
      } catch (error) {
        console.error('Error parsing filterJson:', error);
      }
    }
  }, [gridData, rowData]);

  const filterDefaultSetRef = useRef(null);

  const handleFilterChanged = useCallback(
    (event) => {
      if (filterDefaultSetRef.current) {
        filterDefaultSetRef.current = false;
      } else {
        let filterModel = event.api.getFilterModel();
        console.log('Original Filter Model:', filterModel);

        // Create mappings for campaign names and tag names to their IDs
        const quoteMapping = {};
        if (rowData?.length) {
          rowData.forEach((item) => {
            quoteMapping[item.accountName] = item.id;
          });
        }

        // const tagMapping = {};
        // if (tagsList?.length) {
        //   tagsList.forEach((item) => {
        //     tagMapping[item.name] = item.id;
        //   });
        // }

        const updatedFilterModel = Object.keys(filterModel).reduce((acc, dynamicFilterKey) => {
          let filterData = filterModel[dynamicFilterKey];

          // Convert "set" filters to "text"
          // if (filterData?.filterType === "set") {
          console.log(`Updating ${dynamicFilterKey} from "set" to "text"`, filterData.values);

          if (dynamicFilterKey === 'campaignId') {
            // Convert campaign names to campaign IDs
            const idValues = filterData.values
              .map((name) => quoteMapping[name])
              .filter((id) => id !== undefined);

            if (idValues.length > 0) {
              acc[dynamicFilterKey] = {
                filterType: 'text',
                operator: 'OR',
                conditions: idValues.map((id) => ({
                  filterType: 'text',
                  type: 'contains',
                  filter: id, // Ensure we send ID, not name
                })),
              };
            }
          }
          // else if (dynamicFilterKey === "tagIds") {
          //   // Convert tag names to tag IDs
          //   const idValues = filterData.values
          //     .map((name) => tagMapping[name])
          //     .filter((id) => id !== undefined);

          //   if (idValues.length > 0) {
          //     acc[dynamicFilterKey] = {
          //       filterType: "text",
          //       operator: "OR",
          //       conditions: idValues.map((id) => ({
          //         filterType: "text",
          //         type: "contains",
          //         filter: id, // Ensure we send ID, not name
          //       })),
          //     };
          //   }
          // }

          // Keep Other Filters Unchanged
          else {
            acc[dynamicFilterKey] = filterData;
          }

          return acc;
        }, {});

        console.log('Updated Filter Model:', updatedFilterModel);

        const payload = {
          ...gridData?.inputPayload,
          filterJson: JSON.stringify(updatedFilterModel),
          pageNumber: 1, // Reset to first page on filter change
        };

        console.log('Filter Payload:', payload);

        dispatch(
          fetchDataAndUpdateStore({
            key: 'quoteList',
            inputData: payload,
          })
        );
      }
    },
    [dispatch, gridData?.inputPayload, rowData]
  );

  useEffect(() => {
    setRowData(quoteData);
  }, [quoteData]);

  return (
    <>
      <div className="inner-page" style={containerStyle}>
        <div className="dash-container">
          <div className="tbl_container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12">
                <div className="main-hd">
                  <div className="pagetitle">
                    <img src="../assets/images/role-management-icons/left-arrow.png" alt="" />
                    Quotes
                  </div>
                  <div className="third-div mobView">
                    <div className="dsk">
                      <GlobalSearch moduleName={'quoteList'} />
                    </div>
                    <div className="btnContainer">
                      <div>
                        <button
                          type="button"
                          className="btn btn-outline-primary mobOption export-btn"
                          onClick={exportAll}
                        >
                          <svg
                            width="16px"
                            height="16px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 5L11.2929 4.29289L12 3.58579L12.7071 4.29289L12 5ZM13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14L13 14ZM6.29289 9.29289L11.2929 4.29289L12.7071 5.70711L7.70711 10.7071L6.29289 9.29289ZM12.7071 4.29289L17.7071 9.29289L16.2929 10.7071L11.2929 5.70711L12.7071 4.29289ZM13 5L13 14L11 14L11 5L13 5Z"
                              fill="#333333"
                            />
                            <path
                              d="M5 16L5 17C5 18.1046 5.89543 19 7 19L17 19C18.1046 19 19 18.1046 19 17V16"
                              stroke="#333333"
                              strokeWidth="2"
                            />
                          </svg>{' '}
                          <div className="dsk">Export</div>
                        </button>
                      </div>
                      <div className="dropdown" id="timelogdropdown">
                        <button
                          type="button"
                          className="btn btn-primary createQuotebtn dropdown-toggle"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <span className="dsk">New Quote</span>{' '}
                          <span className="mob">New Quote</span>
                        </button>

                        <ul
                          className="dropdown-menu dropdown-menu-end"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <li className="dropdown-item">
                            <Link to="/quoteAI/regularQuoteAdd">Standard Quote</Link>
                          </li>
                          <li className="dropdown-item" onClick={() => setShow(true)}>
                            <Link>P & C Quote</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mob mb-3">
                  <GlobalSearch moduleName={'quoteAi'} />
                </div>
                <div className="cutome_ag_theme">
                  {loading && <Loader />}
                  <div
                    className={`ag-theme-${selectedTheme} tbl_height`}
                    style={{ width: '100%', height: `calc(100vh - 110px)` }}
                  >
                    <AgGridReact
                      rowData={rowData}
                      columnDefs={columnDefs}
                      defaultColDef={defaultColDef}
                      domLayout="fixedHeight"
                      overlayLoadingTemplate={`<Loader />`}
                      sideBar={sideBar}
                      gridOptions={gridOptions}
                      columnTypes={columnTypes}
                      rowSelection="multiple"
                      enableRangeSelection={true}
                      suppressExcelExport={true}
                      suppressRowClickSelection={true}
                      groupSelectsChildren={true}
                      enableRowGroup={true}
                      onFilterChanged={handleFilterChanged}
                      onGridReady={handleGridReady}
                    />
                    {gridParams && (
                      <FilterHandler
                        params={gridParams}
                        gridData={gridData}
                        columnDefs={columnDefs}
                        filterDefaultSetRef={filterDefaultSetRef}
                      />
                    )}
                  </div>
                </div>
                <Modal
                  show={show}
                  onHide={() => setShow(false)}
                  className="quoteai_popup"
                  backdrop="static"
                  keyboard={false}
                >
                  <Modal.Header closeButton className="title-header">
                    <div>
                      <Modal.Title as="h3">Create New Quote</Modal.Title>
                      <p className="subtitle d-block">
                        Select the line of business and primary state to start a new quote.
                      </p>
                    </div>
                  </Modal.Header>
                  <Modal.Body>
                    {/* Step 1: Line Of Business */}
                    <h4 className="step-title"> Line Of Business</h4>
                    <Row>
                      {businessLines.map((item) => (
                        <Col
                          key={item.id}
                          md={2}
                          sm={12}
                          xs={12}
                          className="mb-3 d-flex justify-content-center"
                        >
                          <div
                            className={`business-card ${item.color} ${selectedBusiness === item.id ? 'selected' : ''}`}
                            onClick={() => setSelectedBusiness(item.id)}
                            style={{ backgroundColor: item.bgColor }}
                          >
                            <div className="business-icon-container">
                              <img src={item.img} alt={item.label} className="popup-icon" />
                            </div>
                            <span className="business-label">{item.label}</span>
                          </div>
                        </Col>
                      ))}
                    </Row>

                    {/* Step 2: Primary State */}
                    <h4 className="step-title d-flex align-items-center">
                      Primary State
                      <span
                        className="ms-2"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content=" Select the primary state for the quote."
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="info-icon"
                          viewBox="0 0 16 16"
                        >
                          <path d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16Z" />
                          <path d="m8.93 6.588-.862.126-.088.45c.176-.098.364-.177.563-.236.198-.059.38-.088.545-.088.235 0 .428.057.578.17.15.114.225.267.225.46 0 .172-.05.311-.15.418-.099.106-.237.196-.412.27-.175.073-.404.166-.688.277-.284.112-.516.244-.695.396-.18.153-.305.333-.376.542-.072.208-.108.467-.108.777h1.002c0-.206.021-.376.063-.512.042-.136.106-.249.192-.34.085-.09.193-.162.324-.215.13-.053.287-.105.47-.157.234-.071.425-.156.572-.253.146-.098.26-.22.342-.366.081-.146.122-.321.122-.523 0-.329-.107-.576-.322-.74-.214-.164-.503-.246-.865-.246-.207 0-.397.025-.572.074Zm-1.862 4.312c0-.238.068-.417.204-.54.136-.122.312-.184.528-.184.216 0 .392.062.528.184.136.123.204.302.204.54 0 .237-.068.416-.204.538-.136.122-.312.183-.528.183-.216 0-.392-.061-.528-.183-.136-.122-.204-.301-.204-.538Z" />
                        </svg>
                      </span>
                      <ReactTooltip
                        id="my-tooltip"
                        style={{ backgroundColor: '#2563eb' }}
                      ></ReactTooltip>
                    </h4>

                    <Form.Group className="state-select-group">
                      <Form.Label>State</Form.Label>
                      <Form.Select
                        value={selectedState}
                        onChange={(e) => setSelectedState(e.target.value)}
                      >
                        {states.map((state, index) => (
                          <option key={index} value={state}>
                            {state}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    {/* Step 3: ACORD Form */}
                    <h4 className="step-title"> Do you have an ACORD form?</h4>
                    <Form.Group>
                      <div className="d-flex align-items-center">
                        <Form.Check
                          type="radio"
                          label="Yes"
                          name="acordForm"
                          id="acordYes"
                          className="me-3"
                          checked={acordForm === 'yes'}
                          onChange={() => setAcordForm('yes')}
                        />
                        <Form.Check
                          type="radio"
                          label="No"
                          name="acordForm"
                          id="acordNo"
                          checked={acordForm === 'no'}
                          onChange={() => setAcordForm('no')} // Just update state, don't navigate immediately
                        />
                      </div>
                    </Form.Group>

                    {/* File Upload Section (Show only if "Yes" is checked) */}
                    {acordForm === 'yes' && (
                      <div className="file-upload-section mt-3">
                        <Form.Group controlId="formFile">
                          <Form.Label className="step-title">Upload ACORD Form</Form.Label>
                          <Form.Control type="file" />
                        </Form.Group>
                      </div>
                    )}
                  </Modal.Body>

                  {/* Footer */}
                  <Modal.Footer className="quote_buttongroup">
                    <Button variant="outline-cancel" onClick={() => setShow(false)}>
                      Cancel
                    </Button>
                    <Button variant="primary-save" onClick={handleStartQuote}>
                      Start Quote
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
